import dayjs from "dayjs";
import { DateInput, RadioButtonGroupInput, useInput } from "react-admin";

export const PublicationFormGroup = () => {
    const startedAtInput = useInput({ source: "publicationStartedAt" });
    const endedAtInput = useInput({ source: "publicationEndedAt" });

    const handleChange = (event: any) => {
        const status = event.target.value;
        // Set the time to 12:00:00.000 to avoid timezone and get the correct date
        // If you omit this your date '2025-01-01' will be '2024-12-31' in some timezones
        const nowDate = dayjs().set("hour", 12).set("minute", 0).set("second", 0).set("millisecond", 0).toDate().getTime();

        if (status === "publishable") {
            startedAtInput.field.onChange(nowDate);
            endedAtInput.field.onChange(null);
        } else {
            if (startedAtInput.field.value != null) {
                endedAtInput.field.onChange(nowDate);
            }
        }
    };

    return (
        <>
            <RadioButtonGroupInput
                source="status"
                onChange={handleChange}
                choices={[
                    { id: "draft", name: "resources.common.choices.contentStatus.draft" },
                    { id: "publishable", name: "resources.common.choices.contentStatus.publishable" }
                ]}
            />
            <DateInput source="publicationStartedAt" />
            <DateInput source="publicationEndedAt" />
        </>
    );
};
